import { i18nGet } from '@/src/tools/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import _TopLeft from 'src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';

//import { useParams } from 'react-router-dom';
import React from 'react';
import { useHistory } from 'react-router';
//import { get } from 'lodash';

const TopLeft = (props) => {
  const { name } = props;
  //const s = useParams();
  // const uuid = get(s, 'uuid');
  //  const discountUuid = get(s, 'discountUuid');
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const h = useHistory();
  const goBack = () => {
    h.push(`/order/giftCard/list`);
  };

  const b = [
    {
      url: '/',
      name: getI18n('general.sider.home'),
    },
    {
      url: `/order/giftCard/list`,
      name: `${getI18n('general.storeCommunicationSetting.order')} / ${getI18n(
        'giftCard.giftCardList.giftCardAndStoreCredit_List_pageLayoutProps_title',
      )}`,
    },
    {
      url: ``,
      name: name,
    },
    // {
    //   url: ``,
    //   name: name,
    // },
  ];
  return <_TopLeft goBack={goBack} breadcrumbData={b} />;
};
export default TopLeft;
